module.exports = __webpack_public_path__ + "static/img/index9.b55e122.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/index9.gif
// module id = kcfj
// module chunks = 0